<template>
  <div class="assessment">
    <div class="title">
      <!-- <div class="hotelName">{{ hotelName }}卫生信息公示</div> -->
    </div>
    <div class="videoBox">
       <video 
       class="my_video"
           src="../../assets/video/video.mp4" 
          id="myvideoback" 
          controls  setAttribute="crossorigin"  
          poster="~@/assets/assess/videoImg.png"
          x5-video-player-type=“h5”
          loop="loop"
          autoplay="autoplay"
          playsinline 
          @click.prevent="videoclick">
        </video>
    </div>   
    <div class="mainBox">
      <div class="mainInfo" v-if="!showAssessBox">
        <div class="item">
          <p><i></i>酒店信息</p>
          <div class="infoRow">单位名称：<span>{{ roomBaseInfo.sitename }}</span></div>
          <div class="infoRow">地址：<span>{{ roomBaseInfo.address }}</span></div>
          <div class="infoRow">卫生许可项目：<span>住宿</span></div>
          <div class="infoRow">卫生监测信息：<span style="color: #11AB23;">合格</span></div>
        </div>
        
        <div class="item">
          <div class="line"></div>
          <p><i></i>保洁信息</p>
          <div class="roomTit">您现在入住的是 <span>{{ roomId }}</span> 房间。
            <!-- 打扫日期为<span style="color: #279d29;">{{ this.date}}</span>。 -->
          </div>
        </div>
        <div class="item">
          <p><i></i>布草更换</p>
          <el-table :data="tableData" border >
           <el-table-column prop="name" label="种类" width="50">
             <template slot-scope="{row}">
               <span v-if="row.name.substring(0, 2) === '56'">枕套</span>
               <span v-if="row.name.substring(0, 2) === '67'">床单</span>
               <span v-if="row.name.substring(0, 2) === '78'">被套</span>
             </template>
           </el-table-column>
           <el-table-column prop="name" label="布草ID" width="120" />
           <el-table-column prop="roomCentralizationTime" label="一客一换一消毒">
             <template slot-scope="{row}">
              <span :class="{'withbtable': row.isReplaceUpStandard==true}">{{ row.isReplaceUpStandard?'':'-' }}</span>
             </template>
           </el-table-column>
          </el-table>
        </div>
        <div class="item">
          <p><i></i>杯具消毒</p>
          <p class="roomInfo">杯具：<span :class="{'withbg':cupInfo!==null&&cupInfo.length!==0}">{{ cupInfo!==null&&cupInfo.length!==0?'已消毒':'-' }}</span></p>
        </div>
        <div class="item">
          <p><i></i>洁具洗消</p>
          <p class="roomInfo">洁具：<span :class="{'withbg':dishclothInfo==true}">{{ dishclothInfo==true?'已消毒':'-' }}</span></p>
        </div>
        <!-- <div class="write" @click="writeAssess">
          <span>写评价</span>
        </div> -->

      </div>
      <div class="assessBox" v-if="showAssessBox">
        <el-input 
          type="textarea" 
          placeholder="展开说说您对本次入住体验的想法吧..." 
          maxlength="100"  
          show-word-limit 
          v-model.trim="textarea"/>
        <el-button type="primary" @click="submitAssess">提交</el-button>
      </div>
    </div>
    <!-- <div class="footer">监管单位: 杭州市西湖区卫生监督所</div> -->
  </div>
</template>
<script>
import { getData,addAssess} from "@/api";
// import moment from "moment";
// addAssess
export default{
  data(){
    return{
      textarea:'',
      showAssessBox:false,
      tableData:[],
      hotelId:null,
      roomId:null,
      hotelName:null,
      cupInfo:null,
      dishclothInfo:null,
      roomBaseInfo:{},
      date:null
    }
  },
  created(){
    // console.log(this.$route.query);
    this.init()
    this.date=(this.$moment().format('MM月DD日')).startsWith('0')?(this.$moment().format('MM月DD日')).slice(1):this.$moment().format('MM月DD日')

  },
  mounted(){

  },
  methods:{
   async init(){
    console.log(this.$route.query);
      this.hotelId=this.$route.query.hotelId
      this.roomId=this.$route.query.roomId
        const res = await getData('0253',this.roomId,)
      // console.log(res);

      if (res.cmd==0) {
        this.hotelName=res.data.hotel.sitename
        res.data.logTextile.sort((a,b)=>{
         return a.name-b.name
        })
        this.tableData=res.data.logTextile
        this.cupInfo =res.data.cups[0]
        this.dishclothInfo =res.data.logStoolDishclothCleanStatus
        this.roomBaseInfo=res.data.hotel
      }
    },
    writeAssess(){
      this.showAssessBox=true
      console.log(this.hotelId,Number(this.hotelId));
    },
    async submitAssess(){
      const params = {feedback:this.textarea,hotelId:Number(this.hotelId),roomNo:this.roomId}
      const res =await addAssess(params)
      console.log(res);
      if (res.code==0&&res.message=='success') {
        this.$message.success('提交成功，感谢您的反馈')
        this.textarea=''
      }
      this.showAssessBox=false
    },
    videoclick(){

    }
  }
}
</script>
<style lang="scss" scoped>
*{
  box-sizing: border-box;
}
.assessment{
  width: 100%;
  height: 100vh;
  background:url('~@/assets/assess/bg.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
  .title{
    padding-top: 35px;
    font-size: 20px;
    text-align: center;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    text-shadow: 0px 4px 0px rgba(16,27,56,0.54);
  }
  .videoBox{
    width: 100%;
    padding:0 15px;
    height: 23.3vh;
    position: absolute;
    top: 10.5vh;
    video{
    border-radius: 7px;
    width: 100%;
    height: 100%;
    object-fit: cover;
    }
  }

  .mainBox{
    width: 100%;
    padding:0 22px 22px 22px;
    position: absolute;
    top: 37vh;
    overflow: scroll;
    
    .mainInfo{
      text-align: center;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #464B64;
      height: 55vh;
      
      .noticeBox{
        color:#FF6600 ;
        padding: 14px 10px 9px 10px;
        div{
          display: flex;
          align-items: flex-start;
          text-align: left;
          &::before{
            content: '';
            display: block;
            background: url('~@/assets/assess/notice.png') no-repeat;
            width:17px ;
            height: 12px;
            background-size: 100% 100%;
            margin-right: 5px;
          }
        }

      }
      
      .item{
        .line{
        border-bottom: 2px dashed rgb(134, 134, 134);
        margin: 5px 0;
      }
        text-align: left;
        padding: 5px 14px 5px 14px;
        p{
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #000000;
          display: flex;
          align-items: center;
          padding: 6px 0;
          i{
            width: 5px;
            height: 16px;
            background: #236DF5;
            border-radius: 2px;
            display: inline-block;
            margin-right: 5px;
          }
        }
      .roomTit{
        span{
          font-size: 16px;
          color:#f8b449;
          font-weight: bold;
          &:last-child{
            font-size: 14px;
            font-weight: normal;
          }
        }
      }
        .infoRow{
          font-size: 16px;
          padding: 7px 0px;
          
        }
        .roomInfo{
          font-size: 13px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #464B64;        
        }
        ::v-deep .el-table{
          .el-table__cell {
           padding: 0;
         }
         th.el-table__cell {
           background: rgb(240, 240, 240);
           color: #333;
         }
         .cell {
           padding: 0;
           text-align: center;
         }
        }
        .withbg{
          color: #11AB23;
        }
        .withbtable{
          color: #11AB23;
          &::before{
            content: '';
            display: inline-block;
            background: url('~@/assets/assess/complete.png') no-repeat;
            width: 17px;
            height: 17px;
            background-size: 100%;
            vertical-align: middle;
            margin-right: 5px;
          }
        }
      }
      .write{
        position: fixed;
        bottom: 7vh;
        right: 50%;
        transform: translateX(50%);
        width: 94px;
        height: 34px;
        background: #FFFFFF;
        border: 1px solid #EAEAEA;
        box-shadow: 0px 2px 2px 0px rgba(84,136,242,0.35);
        border-radius: 4px;
        span{
          font-size: 14px;
          font-weight: 400;
          color: #242424;
          line-height: 34px;
          &::before{
            content: '';
            display: inline-block;
            background: url('~@/assets/assess/assess.png') no-repeat;
            width: 16px;
            height: 16px;
            background-size: 100% 100%;
            margin-right: 12px;
            vertical-align: middle;
          }
        }
        

      }
    }
    .assessBox{
      padding: 10px 15px;
      ::v-deep .el-textarea__inner{
        border: none;
        background-color: transparent;
        height: 70vh !important;
        padding: 0 0 !important;
      }
      button{
        width: 100%;
        margin-top: 15px;
        background-color: #236DF5;
      }
    }
  }
  // .footer{
  //   position: fixed;
  //   text-align: center;
  //   color: #FFFFFF;
  //   bottom: 1vh;
  //   font-size: 14px;
  //   width: 100%;
  // }
}
</style>